import { __exports as CODE128 } from "./index159.js";
import { __require as requireCODE128_AUTO } from "./index160.js";
import { __require as requireCODE128A } from "./index161.js";
import { __require as requireCODE128B } from "./index162.js";
import { __require as requireCODE128C } from "./index163.js";
var hasRequiredCODE128;
function requireCODE128() {
  if (hasRequiredCODE128) return CODE128;
  hasRequiredCODE128 = 1;
  Object.defineProperty(CODE128, "__esModule", {
    value: true
  });
  CODE128.CODE128C = CODE128.CODE128B = CODE128.CODE128A = CODE128.CODE128 = void 0;
  var _CODE128_AUTO = requireCODE128_AUTO();
  var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);
  var _CODE128A = requireCODE128A();
  var _CODE128A2 = _interopRequireDefault(_CODE128A);
  var _CODE128B = requireCODE128B();
  var _CODE128B2 = _interopRequireDefault(_CODE128B);
  var _CODE128C = requireCODE128C();
  var _CODE128C2 = _interopRequireDefault(_CODE128C);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  CODE128.CODE128 = _CODE128_AUTO2.default;
  CODE128.CODE128A = _CODE128A2.default;
  CODE128.CODE128B = _CODE128B2.default;
  CODE128.CODE128C = _CODE128C2.default;
  return CODE128;
}
export {
  requireCODE128 as __require
};
//# sourceMappingURL=index137.js.map
